"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldArray = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var prop_types_1 = tslib_1.__importDefault(require("prop-types"));
var FormContext_1 = tslib_1.__importDefault(require("./FormContext"));
;
/** @deprecated @pinto/react-form is not needed anymore, just use MobX */
var FieldArray = /** @class */ (function (_super) {
    tslib_1.__extends(FieldArray, _super);
    function FieldArray() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FieldArray.prototype.componentWillUnmount = function () {
        var _a;
        (_a = this._unmount) === null || _a === void 0 ? void 0 : _a.call(this);
    };
    FieldArray.prototype.render = function () {
        var _a = this.props, name = _a.name, Klass = _a.component, props = tslib_1.__rest(_a, ["name", "component"]);
        if (!this.context.registerField) {
            throw new Error("<FieldArray name='" + name + "' /> used outside of a <Form />");
        }
        this._unmount = this.context.registerField(this.props.name, this);
        return react_1.default.createElement(Klass, tslib_1.__assign({}, props, this.context.getArrayFieldProps(this)));
    };
    FieldArray.contextType = FormContext_1.default;
    FieldArray.propTypes = {
        name: prop_types_1.default.string.isRequired,
        component: prop_types_1.default.func.isRequired,
    };
    return FieldArray;
}(react_1.default.PureComponent));
exports.FieldArray = FieldArray;
exports.default = FieldArray;
//# sourceMappingURL=FieldArray.js.map